import template from './setup_overtime_rules_help.html'
import * as Utils from '../../lib/savanna_utils.js'

class SetupOvertimeRulesHelpViewModel
{
    constructor(dialog)
    {
        this.dialog = dialog;
    };

    close()
    {
        this.dialog.close();
    }
}

class SetupOvertimeRulesHelpPage
{
    constructor(bindings)
    {
        this.viewModel = new SetupOvertimeRulesHelpViewModel(this)
        this.bindings = bindings
    }

    async init()
    {
        Utils.refresh_data_visible_roles()
    }
}

// Register the dialog
export default {
    name: 'SetupOvertimeRulesHelp',
    dialog_class: SetupOvertimeRulesHelpPage,
    template: template,
    template_filename: 'translation/dialogs/setup_overtime_rules_help',
    provider: 'ps'
}